export const environment = {
    apiUrl : "http://127.0.0.1:8080/api/"
}